import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from "ToolboxUtils/web/context/context";
import { WhiteLabelContext } from "ToolboxUtils/web/context/context";
import PropTypes from 'prop-types';
import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import { EditorWrapper } from './editor.style';

const formats = ['bold','font','color'];

const removePTags = (text) => {
  if (text) {
    return(text.substring(3, text.length-4));
  }
}

const TextEditor = props => {
  const [textualContent, setTextualContent] = useContext(WhiteLabelContext).usePath('textualContent');
  const theme = useContext(ThemeContext).state;
  // const path = props.text.replace('textualContent','');

  let fontFamily = [];
  for(let prop in theme.fontFamily){
    fontFamily.push(theme.fontFamily[prop].toLowerCase());
  }
  let Font = Quill.import('formats/font');
  Font.whitelist = fontFamily;
  Quill.register(Font, true);

  const [editorState, setEditorState] = useState(props.text);
  // for debuging
  // const [editorState, setEditorState] = useState(props.text !== undefined ? props.text : '!undefined!');

  useEffect(() => {
      let text = !props.noRemove ? removePTags(editorState) : editorState;
      setTextualContent(props.path, text);
  }, [editorState]);

  let colorsText = [];
  for(let prop in theme.color){
    colorsText.push(theme.color[prop]);
  }

  const module = {
    toolbar: [
      'bold',
      {'color': colorsText},
      {'font': Font.whitelist}
    ]
  }

  if (!editorState) {
    return null;
  }

  return(
    <EditorWrapper highlighted={props.highlighted}>
      <ReactQuill
        value={editorState}
        onChange={e => setEditorState(e)}
        theme='bubble'
        modules={module}
        formats={formats}
      />
    </EditorWrapper>
  )
};

TextEditor.propTypes = {
  text: PropTypes.string,
  path: PropTypes.string.isRequired,
  highlighted: PropTypes.bool.isRequired,
}

export default TextEditor;
